import Image from 'next/image';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { isDesktopUser } from '../../../Utils/ProductUtils';
import { getScreenName } from '../../../Utils/helper';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { getSearchParams } from '../../Parenting/common';
import ScrollWrapper from '../../ScrollWrapper/ScrollWrapper';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import { tagsMapping, titleImageMapping, titleMappingMob } from '../constant';
import {
  BrandCategoryContainer,
  CategoryCard,
  ExploreBtn,
  GridColumn,
  StaggeredGridSection,
} from './styled';
import { fireEvent } from '../../../Utils/fireEvent';

const StaggeredGrid = (props) => {
  const { categoryData } = props;
  const [cardEffect, setCardEffect] = useState({ index: '', effect: '' });
  const [gridData, setGridData] = useState([]);
  const router = useRouter();

  const manipulatedData = (categoryData, index, parts, offsets, mobile) => {
    let data = categoryData[index];
    const subCategories = data.subCategories.map((cat) => {
      return {
        title: cat.tabName,
        dwebImage: mobile
          ? titleMappingMob[cat?._id]
          : titleImageMapping[cat?._id],
        totalProducts: cat.totalProducts,
        key: cat.key,
        tags: tagsMapping[cat?._id],
      };
    });
    let catData = [];
    for (let i = 0; i < parts; i++) {
      catData.push({ cards: [] });
    }

    for (let i = 0; i < subCategories.length; i++) {
      catData[i % parts]['offset'] = offsets[i % parts];
      if (!catData[i % parts].cards) {
        catData[i % parts].cards = [];
      }
      catData[[i % parts]].cards.push(subCategories[i]);
    }
    // console.log(catData);
    return catData;
  };

  const callbackFunction = (index, deeplinkValue, card) => {
    setCardEffect({ index: index, effect: 'lowOpacity' });
    fireEvent({
      category: 'clicked_card_in_store_home',
      section_name: 'Mylo Care',
      card_name: card?.title,
      screen_name: getScreenName(),
      deeplink: deeplinkValue,
    });
    setTimeout(() => {
      router.push(`${deeplinkValue}` + getSearchParams(), '', {
        locale: getRouterLocale(router),
      });
    }, [200]);
  };

  // ...inside component (keep other code) add this handler:
const exploreCareClick = (deeplink = '/category/mylo-care-7545') => {
  fireEvent({
    category: 'clicked_card_in_store_home',
    section_name: 'Mylo Care',
    card_name: 'explore_care_products',
    shape: 'CTA_BUTTON',
    screen_name: getScreenName(),
    deeplink,
    deeplink_value: deeplink,
    query_params:
      typeof window !== 'undefined' ? window.location.search || 'NA' : 'NA',
    page_url:
      typeof window !== 'undefined'
        ? window.location.href.slice(0, 99)
        : 'NA',
  });

  // Navigate after event
  router.push(`${deeplink}` + getSearchParams(), '', {
    locale: getRouterLocale(router),
  });
};
  const impressionData = {
    category: 'impression_section_in_store_home',
    section_name: 'Mylo Care',
  };

  useEffect(() => {
    const data = isDesktopUser()
      ? manipulatedData(categoryData, 1, 3, ['0', '30px', '100px'])
      : manipulatedData(categoryData, 1, 2, ['0', '30px'], true);
    setGridData(data);
  }, []);

  return (
    <>
      <ScrollWrapper
        data={impressionData}
        sectionId="mylo_baby"
        threshold={0.4}
      >
        <BrandCategoryContainer className="myloCare">
          <div className="brandSection">
            <div className="brandlogoContainer desktopImg">
              <Image
                src="https://images.myloapp.in/NestJsUploads/1697654411860-carelogo.webp"
                className="brandLogo"
                alt=""
                loading="lazy"
                quality={90}
                fill
                sizes="33vw"
              />
            </div>
            <div className="careImgContainer mobileImg">
              <Image
                src="https://images.myloapp.in/NestJsUploads/1697739534448-care-category.webp"
                className="brandImgMobile"
                alt=""
                loading="lazy"
                quality={90}
                fill
                sizes="33vw"
              />
            </div>

            <div className="textSection">
              <h2>Happiness starts with you!</h2>
              <p>
                {
                  'Effective and science-backed personal care and wellness solutions that focus on indulging in self-love, care & quality me-time.'
                }
              </p>
            </div>
            <div className="careImgContainer desktopImg">
              <Image
                src="https://images.myloapp.in/NestJsUploads/1697739534448-care-category.webp"
                className="brandImg"
                alt=""
                loading="lazy"
                quality={90}
                fill
                sizes="33vw"
              />
            </div>
          </div>
          <StaggeredGridSection>
            {gridData.map((item, outerindex) => {
              return (
                <GridColumn
                  key={'gridColumn' + outerindex}
                  paddingTop={item.offset}
                >
                  <div className="offsetTop" />
                  {item.cards.map((card, index) => {
                    return (
                      <AnchorCoverTag
                        url={card?.key}
                        cardEffect={
                          `${outerindex}-${index}` == cardEffect.index
                            ? cardEffect?.effect
                            : ''
                        }
                        callbackFunction={callbackFunction}
                        index={`${outerindex}-${index}`}
                        element={card}
                        key={'categoryCard' + index}
                      >
                        <CategoryCard>
                          <div className="imgContainer">
                            {card.dwebImage && (
                              <Image
                                src={card.dwebImage}
                                quality={100}
                                alt=""
                                loading="lazy"
                                fill
                                sizes="33vw"
                              />
                            )}
                          </div>
                          <div className="categoryInfo">
                            <p>{card.title}</p>
                            <span>{card.tags}</span>
                            <img
                              className="arrowFwd"
                              src={images.backArrowCartBlack}
                              alt=""
                            />
                          </div>
                        </CategoryCard>
                      </AnchorCoverTag>
                    );
                  })}
                </GridColumn>
              );
            })}
          </StaggeredGridSection>
        </BrandCategoryContainer>
        <AnchorCoverTag url={'/category/mylo-care-7545'}
        callbackFunction={()=>{
        exploreCareClick('/category/mylo-care-7545')
        }}
        > 
          <ExploreBtn margins="40px auto -40px">
            Explore Care Products
          </ExploreBtn>
        </AnchorCoverTag>
      </ScrollWrapper>
    </>
  );
};

export default StaggeredGrid;
